import {useAccountContext} from '../lib/accountContext';
import dayjs from 'dayjs';
import {AccountFieldsFragment} from '../api/generated';

export const checkNewAccount = (account?: AccountFieldsFragment | null) => {
  const createdAt = account?.createdAt;
  return dayjs(createdAt).isAfter(dayjs().subtract(1, 'month'));
};

export const useNewAccount = () => {
  const account = useAccountContext();
  return checkNewAccount(account);
};
